import { render, staticRenderFns } from "./RequirementHistory.vue?vue&type=template&id=da2972c4&scoped=true"
import script from "./RequirementHistory.vue?vue&type=script&lang=js"
export * from "./RequirementHistory.vue?vue&type=script&lang=js"
import style0 from "./RequirementHistory.vue?vue&type=style&index=0&id=da2972c4&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da2972c4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('da2972c4')) {
      api.createRecord('da2972c4', component.options)
    } else {
      api.reload('da2972c4', component.options)
    }
    module.hot.accept("./RequirementHistory.vue?vue&type=template&id=da2972c4&scoped=true", function () {
      api.rerender('da2972c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/elements/RequirementHistory.vue"
export default component.exports